// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
// Client V1 imports
const airbrake = require('client/lib/airbrake')

class ErrorBoundary extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true })
    // Send notice to Airbrake in the browser
    airbrake.notify({
      error,
      context: {
        source: 'react',
        info
      }
    })
  }

  render() {
    if (this.state.hasError) {
      // TODO Show a more-substantial error message
      return React.createElement('div', {
        className: 'error'
      },
        `Uh oh. Something went wrong.`
      )
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node
}

module.exports = ErrorBoundary
